import { useShoppingCart } from '../../contexts/ShoppingContext';

const ServiceCard = ({ service }) => {
  const { cart, addToCart, removeFromCart } = useShoppingCart();
  const quantity = cart[service.id] || 0;

  const handleClick = (e, action) => {
    e.preventDefault();
    if (action === 'add') {
      addToCart(service);
    } else {
      removeFromCart(service);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6 flex flex-col h-full">
      <div className="mb-2">
        <span className="text-xs font-medium bg-primary-50 text-primary-600 px-2 py-1 rounded-full">
          {service.categoryName}
        </span>
      </div>
      <h3 className="text-lg font-medium text-gray-900 mb-2">{service.name}</h3>
      <p className="text-gray-500 text-sm mb-4 flex-grow">
        {service.description}
      </p>
      <div className="mt-auto">
        <div className="flex justify-between items-center mb-3">
          <p className="text-primary-600 font-semibold">
            Rs. {service.price.toFixed(2)}
          </p>
          <p className="text-sm text-gray-500">Duration: {service.duration}</p>
        </div>
        <div className="flex justify-end">
          {quantity === 0 ? (
            <button
              onClick={(e) => handleClick(e, 'add')}
              className="text-primary-600 hover:text-primary-700 border-2 border-primary-600 p-2 rounded-full transition-colors"
            >
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                  d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                />
              </svg>
            </button>
          ) : (
            <div className="flex items-center space-x-2">
              <button
                onClick={(e) => handleClick(e, 'remove')}
                className="bg-primary-600 text-white p-1 rounded-full hover:bg-primary-700 transition-colors"
              >
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M20 12H4"
                  />
                </svg>
              </button>
              <span className="font-medium text-gray-900 w-6 text-center">
                {quantity}
              </span>
              <button
                onClick={(e) => handleClick(e, 'add')}
                className="text-primary-600 hover:text-primary-700 border-2 border-primary-600 p-2 rounded-full transition-colors"
              >
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                  />
                </svg>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;
